import React, { Component } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import colors from "stylesheets/utilities/colors.scss";
import "./style.scss";

class ResponseStatus extends Component {
  /**
   * Render either text or SVG
   * @returns {ReactElement|String}
   */
  renderContent() {
    const { isOn, isSmall } = this.props;

    if (isSmall) {
      return (
        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M5 0C2.23859 0 0 2.23857 0 5C0 7.76143 2.23859 10 5 10H11C13.7614 10 16 7.76143 16 5C16 2.23857 13.7614 0 11 0H5ZM8.5 5C8.5 6.933 6.93298 8.5 5 8.5C3.06702 8.5 1.5 6.933 1.5 5C1.5 3.067 3.06702 1.5 5 1.5C6.93298 1.5 8.5 3.067 8.5 5Z" fill={colors.colorGrey4} />
        </svg>
      );
    }

    return isOn ? "Live" : "Hidden";
  }

  render() {
    const { isOn, isSmall } = this.props;

    return (
      <div
        className={classnames(
          "ResponseStatus",
          {
            "ResponseStatus--on": isOn,
            "ResponseStatus--small": isSmall,
            [this.props.customClassName]: Boolean(this.props.customClassName)
          }
        )}
      >
        {this.renderContent()}
      </div>
    );
  }
}

ResponseStatus.propTypes = {
  /** For adding customClassName to parent element */
  customClassName: PropTypes.string,
  /** Show toggle as on or off */
  isOn: PropTypes.bool.isRequired,
  /** Small style option */
  isSmall: PropTypes.bool
};

export default ResponseStatus;
